import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddLoopHelpPage } from './add-loop-help.page';

const routes: Routes = [
  {
    path: '',
    component: AddLoopHelpPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddLoopHelpPageRoutingModule {}
